// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"ArticleTagList_componentStyle__yIW7Y","itemBlock":"ArticleTagList_itemBlock__ojGBu"};